import React, { useEffect, useState } from 'react';
import InputElement from '../Components/InputElement'
import { useRecoilState, useRecoilValue } from 'recoil';
import { ActiveEvents, newEvent, pageDetails, toaster } from '../Recoil/ActiveEvents';
import InputSelectBox from '../Components/InputSelectBox';
import ConfirmationPopup from '../Components/ConfirmationPopup';
import { error } from 'ajv/dist/vocabularies/applicator/dependencies';
const CreateForm = () => {
  const selectedEvent = useRecoilValue(pageDetails);
  const eventDetails = useRecoilValue(ActiveEvents);
  const [proofTypes, setProofTypes] = useState([]);
  const selectedEventName = eventDetails.length > selectedEvent.currentIndex? eventDetails[selectedEvent.currentIndex].EventName:'';
  const [selectedEID, setSelectedEID] = useRecoilState(newEvent);
  const [eventArr, setEventArr] = useState([]);
  const [notify, setNotify] = useRecoilState(toaster);
  const [registrationFormData, setRegistrationFormData] = useState({
    "EventName":"",
    "EventType":"",
    "EventLocation":"",
    "EventStartTime":"",
    "EventDate":"",
    "RegistrationEndDate":"",
    "ContactPerson":"",
    "ContactPersonMobileNo":"",
    "ContactPersonEmailId":"",
    "AlternateContactNo":"",
    "EventDescription":"",
    "Status":"",
    "CreateBy":"",
    "EventDetails": [
        {
            "MarathonName":"",
            "RunningDistance":"",
            "Amount":"",
            "AgeLimit":"",
            "StartLocation":"",
            "EndLocation":"",
            "PriceAmount":'',
            "Status":""
        }
     ]
    });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [getUserForm, setGetUserForm] = useState({EmailId:'',MobileNo:'',"RegistrationId":"",})
  useEffect(() => {
    if(!!selectedEID){
      let eventURI = process.env.REACT_APP_API_URL +"/Events/GetEvent";
      fetch(eventURI ,  {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body:  JSON.stringify(selectedEID)})
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((result) =>{
        let res = result.Events[0];
        res.EventDetails = (result.EventDetails)
        setRegistrationFormData(res)
      }
      )
      .catch((error) => console.error(error));
    }
    let eventURL = process.env.REACT_APP_API_URL +"/Events/GetEventsType";
    fetch(eventURL ,  {
      method: "POST",
      headers: {"Content-Type": "application/json"}})
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((result) =>{
      // console.log(result)
     setEventArr(result.EventsType)
    }
    )
    .catch((error) => console.error(error));
    // Events/GetEvent
    let eventURI = process.env.REACT_APP_API_URL +"/GetIdProof";
    fetch(eventURI ,  {
      method: "GET",
      headers: {"Content-Type": "application/json"}})
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((result) =>{
      setProofTypes(result.IDProofType)
    }
    )
    .catch((error) => console.error(error));
  }, []);

  const handleRegChange = (e, index = -1) => {
    const { name, value } = e.target;
    if(index != -1){
      setRegistrationFormData((prevData) => ({
        ...prevData,
        EventDetails: prevData.EventDetails.map((item, i) =>
          index === i ? { ...item, [name]: value } : item
        )
      }));
    }else{
      setRegistrationFormData({ ...registrationFormData, [name]: value });
    }
  };
  // Validate form data
  const validate = (index) => {
    var newErrors = {};
    const phonePattern = /^[0-9]{10}$/;
    if (registrationFormData.EventName.trim() === '') {
      newErrors.EventName = 'EventName is required';
    } else if (registrationFormData.EventName.length < 5) {
      newErrors.EventName = 'EventName must be at least 5 characters';
    }
    if (registrationFormData.EventType.trim() === '') {
      newErrors.EventType = 'EventType is required';
    }
    if (registrationFormData.EventLocation.trim() === '') {
      newErrors.EventLocation = 'EventLocation is required';
    } else if (registrationFormData.EventLocation.length < 5) {
      newErrors.EventLocation = 'EventLocation must be at least 5 characters';
    }
    if (registrationFormData.EventStartTime.trim() === '') {
      newErrors.EventStartTime = 'EventStartTime is required';
    }
    if (registrationFormData.EventDate.trim() === '') {
      newErrors.EventDate = 'Event Date is required';
    }
    if (registrationFormData.RegistrationEndDate.trim() === '') {
      newErrors.RegistrationEndDate = 'Registration End Date is required';
    }
    if (registrationFormData.ContactPerson.trim() === '') {
      newErrors.ContactPerson = 'Contact Person is required';
    } 
    if (registrationFormData.ContactPersonMobileNo.trim() === '') {
      newErrors.ContactPersonMobileNo = 'MobileNo is required';
    } else if (!phonePattern.test(registrationFormData.ContactPersonMobileNo.trim())) {
      newErrors.ContactPersonMobileNo = 'Mobile Number must be 10 digits';
    }    
    if (registrationFormData.ContactPersonEmailId.trim() === '') {
      newErrors.ContactPersonEmailId = 'ContactPerson EmailId is required';
    } else if (!/\S+@\S+\.\S+/.test(registrationFormData.ContactPersonEmailId)) {
      newErrors.ContactPersonEmailId = 'ContactPerson EmailId is invalid';
    }
    if (registrationFormData.AlternateContactNo.trim() === '') {
      newErrors.AlternateContactNo = 'MobileNo is required';
    } else if (!phonePattern.test(registrationFormData.AlternateContactNo.trim())) {
      newErrors.AlternateContactNo = 'Mobile Number must be 10 digits';
    }  
    if (registrationFormData.EventDescription.trim() === '') {
      newErrors.EventDescription = 'Event Description is required';
    }
    newErrors.EventDetails = [];
    registrationFormData.EventDetails.map((item, i) => {
      let tempObj = {Name:"1"}
      if (item.MarathonName.trim() === '') {
        tempObj.MarathonName = 'Marathon Name is required';
      }
      if (item.RunningDistance.trim() === '') {
        tempObj.RunningDistance = 'Running Distance is required';
      }
      // if (item.Amount.trim() === '') {
      //   tempObj.Amount = 'Amount is required';
      // }
      if (item.AgeLimit.trim() === '') {
        tempObj.AgeLimit = 'AgeLimit is required';
      }
      if (item.StartLocation.trim() === '') {
        tempObj.StartLocation = 'Start Location is required';
      }
      if (item.EndLocation.trim() === '') {
        tempObj.EndLocation = 'End Location is required';
      }
      // if (item.PriceAmount.trim() === '') {
      //   tempObj.PriceAmount = 'Price Amount is required';
      // }
      newErrors.EventDetails.push(tempObj)
    })
    if(selectedEID == null && !file){
      newErrors.images = "Event Image is required."
    }
    if(Object.keys(newErrors).length === 1 && !! newErrors.EventDetails){
      newErrors = {}
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegistrationSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      registrationFormData.Status='S';
    let apiName = !!registrationFormData.EventId ?  "/Events/UpdateEvent" :  "/Events/CreateEvent";
    let eventURI = process.env.REACT_APP_API_URL + apiName;
    fetch(eventURI , {
      method: "POST",
      headers: {
      "Content-Type": "application/json"},
      body: JSON.stringify(registrationFormData),
    })
    .then((response) => response.json())
    .then((result) => {
      handleUpload(result.Events[0].NewId)
      if(!!result.Events[0] && result.Events[0].ErrorMessage == "Success"){
        // setSuccess(true);
        updateValue()
        setNotify({'showPopup': true, 'message':'Event created successfully.',type:'success'})
      }else{
        setNotify({'showPopup': true, 'message':'Event creation failed. Please contact the Admin Team.', type:"error"})
      }
    })
    .catch((error) => console.error(error));
    }
  }

  const updateValue = () => {
    Object.keys(registrationFormData).forEach(key => {
      registrationFormData[key] = ''; 
    });
    registrationFormData.EventName = selectedEventName;
    registrationFormData.EventDetails = [
        {
            "MarathonName":"",
            "RunningDistance":"",
            "Amount":"",
            "AgeLimit":"",
            "StartLocation":"",
            "EndLocation":"",
            "PriceAmount":'',
            "Status":""
        }
     ]
    setTimeout(() => {
      setSuccess(false);
      setErrors({});
    }, 300);
  }

  const handleUserChange = (e)=>{
    const { name, value } = e.target;
    setGetUserForm({ ...getUserForm, [name]: value });
//    setRegistrationFormData({ ...registrationFormData, [name]: value });
  }

  const addNewEvent = (e) => {
    e.preventDefault();
    let newEventObj = {
      "MarathonName":"",
            "RunningDistance":"",
            "Amount":"",
            "AgeLimit":"",
            "StartLocation":"",
            "EndLocation":"",
            "PriceAmount":'',
            "Status":""
    }
    setRegistrationFormData((prevData) => ({
      ...prevData,
      EventDetails: [...prevData.EventDetails, newEventObj]
    }));
    // setRegistrationFormData(...registrationFormData, registrationFormData.EventDetailspush())
  }
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setError('');
    }
  };

  const handleUpload = async (eventID) => {
    if(!!selectedEID && !file){
      setSuccess(true)
      return '';
    }
    if (!file) {
      setError('Please select a file first.');
      return;
    }
    // setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append("FName", file.name);
      formData.append("EventName", eventID);
      let eventURI = process.env.REACT_APP_API_URL + "/UploadFiles";
      fetch(eventURI , {
        method: "POST",
        body: formData
      })
      .then((response) => response.json())
      .then((result) => {
        if(!!result && result == "File Upoaded"){
          setNotify({'showPopup': true, 'message':'Event created and file uploaded successfully.',type:'success'})
          setFile(null);
        }else{
          setNotify({'showPopup': true, 'message':'Event file upload failed. Please contact the Admin Team.',type:'success'})
        }
        setSuccess(true)
      })
      .catch((error) => console.error(error));

    } catch (error) {
      console.error('Upload failed:', error);
      // setUploading(false);
      setError('Upload failed. Please try again.');
    }
  };

  return <div className='max-w-[1024px] mx-auto px-4 pt-12'>
    <div>
        <h2 className='text-dark-gray text-2xl font-medium'>Create New Event</h2>
        <h4>Ready, Set, Go! Register for the Marathon</h4> 
            <div>
              <form onSubmit={handleRegistrationSubmit} className="space-y-4 pt-7" id="regForm">
                <div className="grid grid-cols-1 md:grid-cols-2 md:grid-cols-2 gap-4">
                  {/* row 1 */}
                    <div>
                      <InputElement value={registrationFormData.EventName} errors={errors.EventName} Label='Event Name' elementName='EventName'  handleRegChange = {(e)=>handleRegChange(e)}/>
                    </div>
                    <div>
                      <InputSelectBox  errors={errors.EventType} Label='Name of  the Event' elementName='EventType' handleRegChange = {(e)=>handleRegChange(e)} value={registrationFormData.EventType} arrOptions={eventArr} type="EventName"/>
                    </div>
                    {/* row 2 */}
                    <div>
                      <InputElement value={registrationFormData.EventLocation} errors={errors.EventLocation} Label='Event Location' elementName='EventLocation'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                      <InputElement value={registrationFormData.EventStartTime} errors={errors.EventStartTime} Label=' Event StartTime' elementName='EventStartTime'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 3 */}
                      <div>
                        <InputElement value={registrationFormData.EventDate} errors={errors.EventDate} Label='Event Date' elementName='EventDate'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                      </div>
                      <div>
                        <InputElement value={registrationFormData.RegistrationEndDate} errors={errors.RegistrationEndDate} Label='Registration End Date' elementName='RegistrationEndDate'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                      </div>
                    {/* row 4 */}
                    <div>
                      <InputElement value={registrationFormData.ContactPerson} errors={errors.ContactPerson} Label='Contact Person' elementName='ContactPerson'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                        <InputElement value={registrationFormData.ContactPersonMobileNo} errors={errors.ContactPersonMobileNo} Label='ContactPerson MobileNo' elementName='ContactPersonMobileNo'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 5 */}
                    <div>
                      <InputElement value={registrationFormData.ContactPersonEmailId} errors={errors.ContactPersonEmailId} Label='Contact PersonEmailId' elementName='ContactPersonEmailId'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    <div>
                        <InputElement value={registrationFormData.AlternateContactNo} errors={errors.AlternateContactNo} Label='ContactPerson AlternateContactNo' elementName='AlternateContactNo'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                    {/* row 6 */}
                    <div>
                      <InputElement value={registrationFormData.EventDescription} errors={errors.EventDescription} Label='Event Description' elementName='EventDescription'  handleRegChange = {(e)=>handleRegChange(e)}/> 
                    </div>
                </div>
                <div className="flex justify-between">
                <h1 className='text-t-20'>Event Details</h1>
                  <button onClick={addNewEvent} className="bg-yellow-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75">Add Event</button>
                </div>
                  {registrationFormData.EventDetails.map((currentEvent, index) => {
                    const err = !!errors.EventDetails && !!errors.EventDetails[index] ?  errors.EventDetails[index] : {};
                    return(
                    <div className="grid grid-cols-1 md:grid-cols-2 md:grid-cols-2 gap-4" key={index}>
                      <h1 className='text-t-20'>Event {(index +1)}</h1> <br/>
                      {/* row 1 */}
                        <div>
                          <InputElement value={currentEvent.MarathonName} errors={err.MarathonName} Label='Marathon Name' elementName='MarathonName'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        <div>
                            <InputElement value={currentEvent.RunningDistance} errors={err.RunningDistance} Label='RunningDistance' elementName='RunningDistance'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        {/* row 2 */}
                        <div>
                            <InputElement value={currentEvent.Amount} errors={err.Amount} Label='Amount' elementName='Amount'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        <div>
                          <InputElement value={currentEvent.AgeLimit} errors={err.AgeLimit} Label=' AgeLimit' elementName='AgeLimit'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        {/* row 3 */}
                        <div>
                          <InputElement value={currentEvent.StartLocation} errors={err.StartLocation} Label=' Start Location' elementName='StartLocation'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        <div>
                          <InputElement value={currentEvent.EndLocation} errors={err.EndLocation} Label=' End Location' elementName='EndLocation'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        <div>
                          <InputElement value={currentEvent.PriceAmount} errors={err.PriceAmount} Label=' Price Amount' elementName='PriceAmount'  handleRegChange = {(e)=>handleRegChange(e, index)}/> 
                        </div>
                        {/* row 3 */}
                    </div>
                    )
                  })}
                  <div>
                    <h1 className='text-t-20'>Event Image</h1>
                  </div>
                  <div className="max-w-md mt-10">
                    <div className="border-2 border-dashed border-gray-300 p-4 rounded-lg flex flex-col ">
                      <input
                        type="file"
                        onChange={handleFileChange}
                        className="mb-4 px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                      {file && (
                        <p className="text-gray-700 mb-2">Selected file: {file.name}</p>
                      )}
                      {error && (
                        <p className="text-red-500 mb-2">{error}</p>
                      )}
                      {errors.images && (
                        <p className="text-red-500 text-sm mt-1">{errors.images}</p>
                      )}
              
                    </div>
                  </div>
                <div>
                  <button
                    type="submit"
                    className="bg-red-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75"
                  >
                    Create Event
                  </button>
                  {errors && Object.keys(errors).length > 0 ? ( <p className='pt-2 text-red-700'>Fill all the mandatory fileds</p> ) : ''}
                </div>
              </form>
            </div>
        {/* <ConfirmationPopup popup={success} message="New Event created sucessfully." clearValue={()=>updateValue()}/> */}
    </div>
  </div>;
};

export default CreateForm;